import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const PersonIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.000651684 18.0491C0.388258 12.3815 4.26191 9.5 8.98334 9.5C13.7712 9.5 17.7049 12.2232 17.9979 18.05C18.0096 18.2821 17.9979 19 17.2467 19H0.727503C0.476713 19 -0.0204618 18.3578 0.000651684 18.0491Z"
        {...svgAttrs}
      />
      <circle cx="9" cy="4" r="4" {...svgAttrs} />
    </svg>
  );
};

export default PersonIcon;
